import React, { Component } from "react";
import EditAppointment from "./EditAppointment";
import { ContinueDealWithStateProps } from "./lib";
import ScheduleAppointment from "./ScheduleAppointment";
import withState from "./state";

class ScheduleAppointmentEntry extends Component<any> {
    public render() {
        const hasExisting = !!(this.props.appointmentDate && this.props.appointmentTime);

        const RenderThis = !hasExisting ? withState(ScheduleAppointment) : withState(EditAppointment);

        return <RenderThis {...(this.props as ContinueDealWithStateProps)} />;
    }
}

export default ScheduleAppointmentEntry;
